import React from 'react';
import CenterCenterVerticalContainer from '../../components/layout/CenterCenterVerticalContainer';
import TitleContainerComponent from '../../components/layout/TitleContainerComponent';
import MainPageComponent from '../../components/page/MainPageComponent';

function GuestHome() {

    let breadcrumbPath = [
        {value:'Inicio', href:''}
    ];

    return (
        <MainPageComponent requireAuthentication={false} path={breadcrumbPath} >
            <CenterCenterVerticalContainer>
                <div>
                    <TitleContainerComponent>
                        <h1>Que tus finanzas no te dominen.</h1>
                    </TitleContainerComponent>
                    <p>Empieza ahora a mejorar tus finanzas,
                        te ofrecemos una forma sencilla de hacerlo.</p>
                </div>
            </CenterCenterVerticalContainer>
        </MainPageComponent>
    );
}

export default GuestHome;